var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhoneBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19156 9.11128C3.71293 6.9891 3.17165 5.77957 4.53288 4.82179C5.70358 3.99795 5.62608 3.9062 4.5732 1.86128C3.60033 -0.0280594 3.19506 -0.516622 1.85577 0.568404C-1.12279 2.6486 -0.33 6.02436 2.90969 10.6741C6.14939 15.3241 9.15426 17.2288 12.0384 15.1834C13.511 14.2897 13.1928 13.7398 11.7589 12.1751C10.2069 10.4814 10.1326 10.3974 8.9817 11.2074C7.64054 12.1511 6.67018 11.2334 5.19156 9.11128Z",
    fill: "#6F7DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhoneBlue);
export default __webpack_public_path__ + "static/media/ic_phone_blue.c43d97ddf5d1ac9ba4ce7cd2dd18d29d.svg";
export { ForwardRef as ReactComponent };